// src/pages/printRAPage.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import printJS from 'print-js';
import './printRAPage.css';
import { useAuth } from '../context/AuthContext';

function PrintRAPage() {
    const { user, isLoadingAuth, interceptorsReady } = useAuth();
    
    const [clientData, setClientData] = useState(null);
    const [summary, setSummary] = useState(null);
    const [movements, setMovements] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentDate, setCurrentDate] = useState('');
    const [showArchived, setShowArchived] = useState(false);

    // Format date
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('es-AR', { 
            year: 'numeric', 
            month: '2-digit', 
            day: '2-digit' 
        });
    };

    // Format price
    const formatPrice = (price) => {
        if (typeof price !== 'number' || isNaN(price)) return '$ 0,00';
        return `$ ${price.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    // Print function
    const handlePrint = () => {
        printJS({
            printable: 'print-ra-content',
            type: 'html',
            scanStyles: false,
            style: `
                @page { 
                    margin: 15mm; 
                    size: A4;
                }
                
                * { 
                    box-sizing: border-box; 
                    margin: 0; 
                    padding: 0; 
                }
                
                body { 
                    margin: 0 !important; 
                    padding: 0 !important; 
                    font-family: 'Arial', sans-serif;
                    font-size: 10pt;
                    color: #000;
                }
                
                .print-ra-container {
                    width: 100%;
                    padding: 10mm;
                    background: #fff;
                    color: #000;
                }
                
                .ra-header {
                    text-align: center;
                    margin-bottom: 20px;
                    border-bottom: 2px solid #000;
                    padding-bottom: 10px;
                }
                
                .ra-header h1 {
                    font-size: 18pt;
                    margin-bottom: 5px;
                    color: #000;
                }
                
                .ra-header .subtitle {
                    font-size: 12pt;
                    color: #666;
                }
                
                .ra-client-info {
                    margin-bottom: 20px;
                    padding: 10px;
                    border: 1px solid #ddd;
                    background: #f9f9f9;
                }
                
                .ra-client-info h2 {
                    font-size: 14pt;
                    margin-bottom: 10px;
                    color: #000;
                }
                
                .ra-client-info .info-row {
                    display: flex;
                    margin-bottom: 5px;
                    font-size: 10pt;
                }
                
                .ra-client-info .info-label {
                    font-weight: bold;
                    width: 150px;
                    color: #333;
                }
                
                .ra-client-info .info-value {
                    color: #000;
                }
                
                .ra-summary {
                    margin-bottom: 20px;
                    padding: 10px;
                    background: #fff3cd;
                    border: 1px solid #ffc107;
                }
                
                .ra-summary h3 {
                    font-size: 12pt;
                    margin-bottom: 10px;
                    color: #000;
                }
                
                .summary-grid {
                    display: flex;
                    flex-direction: row;
                    gap: 12px;
                }
                
                .summary-item {
                    flex: 1;
                    min-width: 0;
                }
                
                .summary-item .label {
                    font-weight: bold;
                    color: #555;
                    font-size: 8pt;
                    text-transform: uppercase;
                    margin-bottom: 4px;
                }
                
                .summary-item .value {
                    font-size: 13pt;
                    font-weight: bold;
                    color: #000;
                    padding: 0;
                    background: none;
                    border: none;
                    text-decoration: none;
                }
                
                .summary-item .value.debit {
                    color: #d32f2f;
                }
                
                .summary-item .value.balance {
                    color: #000;
                }
                
                .summary-item .value.updated {
                    color: #d46b08;
                    font-size: 9pt;
                    font-weight: normal;
                    margin-top: 4px;
                    border: none;
                    text-decoration: none;
                }
                
                .ra-movements {
                    margin-bottom: 20px;
                }
                
                .ra-movements h3 {
                    font-size: 12pt;
                    margin-bottom: 10px;
                    color: #000;
                    border-bottom: 1px solid #000;
                    padding-bottom: 5px;
                }
                
                .movement-block {
                    margin-bottom: 15px;
                    padding: 10px;
                    border: 1px solid #ddd;
                    page-break-inside: avoid;
                }
                
                .movement-header {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 8px;
                    padding-bottom: 5px;
                    border-bottom: 1px dashed #999;
                    font-weight: bold;
                }
                
                .movement-type {
                    font-size: 11pt;
                    color: #000;
                }
                
                .movement-date {
                    font-size: 10pt;
                    color: #666;
                }
                
                .movement-details {
                    margin-bottom: 8px;
                    font-size: 9pt;
                }
                
                .movement-details .detail-row {
                    display: flex;
                    margin-bottom: 3px;
                }
                
                .movement-details .detail-label {
                    font-weight: bold;
                    width: 120px;
                    color: #666;
                }
                
                .movement-details .detail-value {
                    color: #000;
                }
                
                .movement-items-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 8px;
                    font-size: 9pt;
                }
                
                .movement-items-table th {
                    background: #f5f5f5;
                    padding: 5px;
                    text-align: left;
                    border: 1px solid #ddd;
                    font-weight: bold;
                    color: #000;
                }
                
                .movement-items-table td {
                    padding: 5px;
                    border: 1px solid #ddd;
                    color: #000;
                }
                
                .movement-items-table .col-code {
                    width: 15%;
                }
                
                .movement-items-table .col-description {
                    width: 45%;
                }
                
                .movement-items-table .col-quantity {
                    width: 10%;
                    text-align: center;
                }
                
                .movement-items-table .col-price {
                    width: 15%;
                    text-align: right;
                }
                
                .movement-items-table .col-subtotal {
                    width: 15%;
                    text-align: right;
                    font-weight: bold;
                }
                
                .movement-amounts {
                    display: flex;
                    justify-content: flex-end;
                    gap: 20px;
                    margin-top: 10px;
                    padding-top: 5px;
                    border-top: 1px solid #ddd;
                    font-weight: bold;
                }
                
                .amount-item {
                    font-size: 10pt;
                }
                
                .amount-item.debit {
                    color: #d32f2f;
                }
                
                .amount-item.credit {
                    color: #388e3c;
                }
                
                .ra-footer {
                    margin-top: 30px;
                    padding-top: 10px;
                    border-top: 1px solid #000;
                    text-align: center;
                    font-size: 9pt;
                    color: #666;
                }
                
                .no-print {
                    display: none !important;
                }
            `
        });
    };

    useEffect(() => {
        if (isLoadingAuth || !interceptorsReady) {
            return;
        }

        const fetchData = async () => {
            try {
                // Get client ID from URL hash parameters
                const hashParts = window.location.hash.split('?');
                const queryString = hashParts.length > 1 ? hashParts[1] : window.location.search.substring(1);
                const params = new URLSearchParams(queryString);
                const clientId = params.get('clientId');

                if (!clientId) {
                    setError('No se especificó el cliente');
                    setLoading(false);
                    return;
                }

                // Set current date
                const now = new Date();
                setCurrentDate(now.toLocaleDateString('es-AR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                }));

                // Fetch client movements — always include archived so the toggle can show/hide them client-side
                const response = await axios.get(
                    `https://horizontepyme.proyectoshorizontales.com/apitest/runningaccount/client/${clientId}/movements?includeItems=true&includeArchived=true`
                );

                if (response.data.success) {
                    setClientData(response.data.client);
                    setSummary(response.data.summary);
                    setMovements(response.data.movements || []);
                } else {
                    setError('Error al cargar datos del cliente');
                }

                setLoading(false);
            } catch (err) {
                console.error('[PrintRAPage] Error fetching data:', err);
                setError('Error al cargar datos: ' + (err.message || 'Error desconocido'));
                setLoading(false);
            }
        };

        fetchData();
    }, [isLoadingAuth, interceptorsReady]);

    // Get movement type label
    const getMovementTypeLabel = (movement) => {
        const types = {
            'CARGO': `CARGO - ${movement.descripcion || 'Productos agregados'}`,
            'PAGO': 'PAGO',
            'ADELANTO': 'ADELANTO / SEÑA',
            'AJUSTE_CREDITO': 'AJUSTE A FAVOR',
            'AJUSTE_DEBITO': 'AJUSTE EN CONTRA',
            'ANULACION': 'ANULACIÓN'
        };
        return types[movement.tipo] || movement.tipo;
    };

    if (loading) {
        return (
            <div className="print-ra-container">
                <div className="ra-header">
                    <h1>Cargando...</h1>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="print-ra-container">
                <div className="ra-header">
                    <h1>Error</h1>
                    <p>{error}</p>
                </div>
            </div>
        );
    }

    return (
        <div>
            {/* Print Button (hidden on print) */}
            <div className="no-print" style={{ 
                position: 'fixed', 
                top: '20px', 
                right: '20px', 
                zIndex: 1000,
                display: 'flex',
                gap: '10px'
            }}>
                <button 
                    onClick={handlePrint}
                    style={{
                        padding: '12px 24px',
                        fontSize: '14px',
                        backgroundColor: '#1890ff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}
                >
                    🖨️ Imprimir
                </button>
                <button 
                    onClick={() => window.close()}
                    style={{
                        padding: '12px 24px',
                        fontSize: '14px',
                        backgroundColor: '#666',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}
                >
                    ✕ Cerrar
                </button>
                {/* Archived toggle */}
                <button
                    onClick={() => setShowArchived(prev => !prev)}
                    style={{
                        padding: '12px 20px',
                        fontSize: '14px',
                        backgroundColor: showArchived ? '#595959' : '#d9d9d9',
                        color: showArchived ? 'white' : '#333',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}
                >
                    {showArchived ? '🗄️ Ocultar Archivados' : '🗄️ Mostrar Archivados'}
                </button>
            </div>

            {/* Printable Content */}
            <div id="print-ra-content" className="print-ra-container">
                {/* Header */}
                <div className="ra-header">
                    <h1>ESTADO DE CUENTA ABIERTA</h1>
                    <div className="subtitle">Fecha de emisión: {currentDate}</div>
                </div>

                {/* Client Info */}
                {clientData && (
                    <div className="ra-client-info">
                        <h2>Datos del Cliente</h2>
                        <div className="info-row">
                            <span className="info-label">Nombre / Razón Social:</span>
                            <span className="info-value">{clientData.businessName || clientData.displayName}</span>
                        </div>
                        {clientData.documentNumber && (
                            <div className="info-row">
                                <span className="info-label">Documento:</span>
                                <span className="info-value">{clientData.documentNumber}</span>
                            </div>
                        )}
                        <div className="info-row">
                            <span className="info-label">Condición IVA:</span>
                            <span className="info-value">{clientData.taxCondition || 'N/A'}</span>
                        </div>
                        {clientData.creditLimit && (
                            <div className="info-row">
                                <span className="info-label">Límite de Crédito:</span>
                                <span className="info-value">{formatPrice(clientData.creditLimit)}</span>
                            </div>
                        )}
                    </div>
                )}

                {/* Summary */}
                {summary && (
                    <div style={{
                        marginBottom: 20,
                        padding: 15,
                        background: '#fff3cd',
                        border: '1px solid #ffc107',
                        borderRadius: 4
                    }}>
                        <div style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 14, color: '#000' }}>Resumen de Cuenta</div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: 24,
                        }}>
                            {/* SALDO ACTUAL */}
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontSize: 10, fontWeight: 'bold', color: '#555', textTransform: 'uppercase', marginBottom: 4 }}>Saldo Actual:</div>
                                <div style={{ fontSize: 22, fontWeight: 'bold', color: '#000' }}>{formatPrice(summary.saldoActual)}</div>
                            </div>
                            {/* ITEMS SIN FACTURAR */}
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontSize: 10, fontWeight: 'bold', color: '#555', textTransform: 'uppercase', marginBottom: 4 }}>Items sin Facturar:</div>
                                <div style={{ fontSize: 22, fontWeight: 'bold', color: '#000' }}>{summary.productosSinFacturar || 0}</div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Movements */}
                <div className="ra-movements">
                    <h3>Detalle de Movimientos{!showArchived && movements.some(m => m.isArchived) ? ' (archivados ocultos)' : ''}</h3>
                    
                    {(() => {
                        const visibleMovements = showArchived
                            ? movements
                            : movements.filter(m => !m.isArchived);
                        return visibleMovements.length === 0 ? (
                            <p style={{ textAlign: 'center', color: '#666', padding: '20px' }}>
                                No hay movimientos registrados
                            </p>
                        ) : (
                            visibleMovements.map((movement) => (
                            <div key={movement.id} className="movement-block">
                                {/* Movement Header */}
                                <div className="movement-header">
                                    <span className="movement-type">
                                        {getMovementTypeLabel(movement)}
                                    </span>
                                    <span className="movement-date">
                                        {formatDate(movement.fecha)}
                                    </span>
                                </div>

                                {/* Movement Details */}
                                <div className="movement-details">
                                    {movement.transactionId && (
                                        <div className="detail-row">
                                            <span className="detail-label">Referencia:</span>
                                            <span className="detail-value">{movement.transactionId}</span>
                                        </div>
                                    )}
                                    {movement.notasInternas && (
                                        <div className="detail-row">
                                            <span className="detail-label">Notas:</span>
                                            <span className="detail-value">{movement.notasInternas}</span>
                                        </div>
                                    )}
                                    {movement.invoiceNumber && (
                                        <div className="detail-row">
                                            <span className="detail-label">Factura:</span>
                                            <span className="detail-value">{movement.invoiceNumber}</span>
                                        </div>
                                    )}
                                    {movement.pickedUp && (
                                        <div className="detail-row">
                                            <span className="detail-label">Estado Retiro:</span>
                                            <span className="detail-value">
                                                ✓ Retirado {movement.pickedUpBy ? `por ${movement.pickedUpBy}` : ''}
                                                {movement.pickedUpAt && ` el ${formatDate(movement.pickedUpAt)}`}
                                            </span>
                                        </div>
                                    )}
                                    {movement.descuentoPorcentaje > 0 && (
                                        <div className="detail-row">
                                            <span className="detail-label">Descuento:</span>
                                            <span className="detail-value">
                                                {movement.descuentoPorcentaje}% ({formatPrice(movement.descuentoMonto)})
                                            </span>
                                        </div>
                                    )}
                                </div>

                                {/* Items Table (only for CARGO movements) */}
                                {movement.items && movement.items.length > 0 && (
                                    <table className="movement-items-table">
                                        <thead>
                                            <tr>
                                                <th className="col-code">Código</th>
                                                <th className="col-description">Descripción</th>
                                                <th className="col-quantity">Cant.</th>
                                                <th className="col-price">Precio Unit.</th>
                                                <th className="col-subtotal">Subtotal</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {movement.items.map((item) => (
                                                <tr key={item.id}>
                                                    <td className="col-code">{item.productCode}</td>
                                                    <td className="col-description">{item.productName}</td>
                                                    <td className="col-quantity">{item.quantity}</td>
                                                    <td className="col-price">{formatPrice(item.unitPriceAtLoad)}</td>
                                                    <td className="col-subtotal">{formatPrice(item.subtotalAtLoad)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}

                                {/* Movement Amounts */}
                                <div className="movement-amounts">
                                    {movement.debe > 0 && (
                                        <div className="amount-item debit">
                                            DEBE: {formatPrice(movement.debe)}
                                        </div>
                                    )}
                                    {movement.haber > 0 && (
                                        <div className="amount-item credit">
                                            HABER: {formatPrice(movement.haber)}
                                        </div>
                                    )}
                                    <div className="amount-item">
                                        Saldo: {formatPrice(movement.saldoAcumulado)}
                                    </div>
                                </div>
                            </div>
                        ))
                        );
                    })()}
                </div>

                {/* Footer */}
                <div className="ra-footer">
                    <p>Este documento es un estado de cuenta informativo.</p>
                    <p>Para cualquier consulta, por favor contacte con su ejecutivo de cuenta.</p>
                </div>
            </div>
        </div>
    );
}

export default PrintRAPage;
